export default "__VITE_ASSET__LHz0OR2q__"